import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "vuetify/lib/locale/en";
import pt from "vuetify/lib/locale/pt";
import es from "vuetify/lib/locale/es";
import enMessages from './locales/en.json'
import ptMessages from './locales/pt.json'
import esMessages from './locales/es.json'

Vue.use(VueI18n);

const messages = {
  en: {
    $vuetify: en,
    ...enMessages
  },
  pt: {
    $vuetify: pt,
    ...ptMessages
  },
  es: {
    $vuetify: es,
    ...esMessages
  }
};
    
// A chave do localStorage e a mesma que utils.js e pdfUtils.js leem para
// formatar data - trocar o nome aqui exige trocar la tambem.
export const LOCALE_STORAGE_KEY = 'userLanguage';

// A lista de idiomas oferecidos, com o rotulo que aparece na tela. Fonte unica:
// o radio do SettingsModal e o seletor da tela de login leem daqui, entao
// acrescentar um idioma e mexer em `messages` e nesta lista, e mais nada.
//
// O rotulo e o codigo do IDIOMA, nao a bandeira/pais: "US"/"BR" dizia que
// portugues e do Brasil e ingles dos EUA, o que ja era discutivel e fica
// insustentavel no espanhol - nao ha um pais obvio para representa-lo.
export const AVAILABLE_LOCALES = [
  { value: 'en', label: 'EN' },
  { value: 'pt', label: 'PT' },
  { value: 'es', label: 'ES' },
];

const initialLocale = localStorage.getItem(LOCALE_STORAGE_KEY) || 'pt';

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: 'pt',
  messages,
});

// Trocar de idioma sao duas escritas que andam juntas: a que muda a tela agora
// e a que sobrevive ao reload (lida pelo initialLocale acima). Elas viviam
// soltas dentro do SettingsModal; quem quiser trocar o idioma de qualquer outro
// lugar - a tela de login, por exemplo - chama isto, e nao ha um segundo lugar
// para esquecer uma das duas.
export function setLocale(lang) {
  if (!messages[lang]) return i18n.locale;
  i18n.locale = lang;
  localStorage.setItem(LOCALE_STORAGE_KEY, lang);
  return lang;
}

export default i18n;
